<template>
  <div class="header-button-wrapper">
    <button type="button" class="header-button push-hamburger"
    :aria-expanded="isActive ? 'true' : 'false'"
    aria-controls="global-nav"
    aria-label="メニュー開閉"
    @click="hamburgerMenuClick">
      <span class="push-hamburger-line"></span>
      <transition appear name="fade">
        <div class="header-button-text" v-if="isActive === false">
          <div>MENU</div>
        </div>
        <ul v-else>
          <li><router-link to="/about">About</router-link></li>
          <li><router-link to="/works">Works</router-link></li>
          <li><router-link to="/contact">Contact</router-link></li>
          <li><router-link to="/introduction">Introduction</router-link></li>
        </ul>
      </transition>
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    hamburgerMenuClick() {
      this.isActive = !this.isActive;
    }
  }
}
</script>

<style lang="scss" scoped>
 .header-button-wrapper {
   display: flex;
   flex-direction: column;
   position: fixed;
   right: 20px;
   z-index: 999;
 }

.header-button {
  position: relative;
  display: inline-block;
  text-decoration: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: none;
  background-color: transparent;
  cursor: pointer;
  outline: none
}

.push-hamburger {
  width: 20px;
  height: 20px;
  margin: auto;
  box-shadow: 0 0 2rem transparent;
  -webkit-transition: all .3s ease-in-out;
        transition: all .3s ease-in-out;
}

.push-hamburger-line {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 25px;
  height: 2px;
  background-color: $colorBrown;
  -webkit-transition: inherit;
          transition: inherit;
}

.push-hamburger-line::before,
.push-hamburger-line::after {
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  background-color: inherit;
  content: '';
  -webkit-transition: inherit;
          transition: inherit;
}

.push-hamburger-line {
  &::before {
    top: -8px;
  }
  &::after {
    top: 8px;
  }
}

.push-hamburger:hover .push-hamburger-line::after,
.push-hamburger:focus .push-hamburger-line::after{
  width: 12.5px;

}

.push-hamburger[aria-expanded ="true"] {
  .push-hamburger-line{
    background-color: transparent;
  }
  .push-hamburger-line {
    &::before {
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
    &::after {
      -webkit-transform: rotate(-45deg);
      -ms-transform: rotate(-45deg);
      transform: rotate(-45deg);
    }
  }
}

.push-hamburger[aria-expanded ="true"] .push-hamburger-line::before ,
.push-hamburger[aria-expanded ="true"] .push-hamburger-line::after{
  top: 0;
  background-color: $colorBrown;
  width: 25px;
}

.header-button-text {
  position: absolute;
  top: 23px;
  left: -2px;
  div {
    font-size: 10px;
    margin-top: -10px;
    padding-top: 10px;
  }
}

.header-button-wrapper {
  ul {
    position: absolute;
    right: 0;
    top: 10px;
    -webkit-transition: all .3s ease-in-out;
    transition: all .3s ease-in-out;
    margin: 18px 0;
    li {
      font-size: 15px;
      text-align: right;
      line-height: 1.5rem;
      -webkit-transition: all .3s ease-in-out;
        transition: all .3s ease-in-out;
      a {
        position: relative;
        display: inline-block;
        &::after {
          position: absolute;
          left: 0;
          content: '';
          width: 0;
          bottom: -2px;
          height: 2px;
          background: $colorBrown;
          opacity: 0;
          visibility: hidden;
          transition: .3s;
        }
      }
    }
  }
}

ul > li > a:hover::after,
ul > li > a:focus::after {
  opacity: 1;
  width: 100%;
  visibility: visible;
}

</style>